
import { reactive } from 'vue'
import ModalBase from '@/components/genenral/ModalBase.vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
export default {
  name: 'ModalInputCaution',

  components: {
    ModalBase
  },
  setup() {
    const router = useRouter()
    const store = useStore()

    const modalState = reactive({
      isShow: false
    })

    const closeModal = () => {
      store.commit('unFixBody')
      modalState.isShow = false
    }
    const openModal = () => {
      modalState.isShow = true
    }
    const moveToContact = () => {
      store.commit('unFixBody')
      const url = router.resolve('/contact/input')
      window.open(url.href, '_blank')
    }

    return {
      modalState,
      closeModal,
      moveToContact,
      openModal
    }
  }
}
